import { render, staticRenderFns } from "./Dedication.vue?vue&type=template&id=c7a64f22&scoped=true"
import script from "./Dedication.vue?vue&type=script&lang=js"
export * from "./Dedication.vue?vue&type=script&lang=js"
import style0 from "./Dedication.vue?vue&type=style&index=0&id=c7a64f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a64f22",
  null
  
)

export default component.exports